import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";

interface OpportunityMediaProps {
  opportunityId: string;
}

export const OpportunityMedia = ({ opportunityId }: OpportunityMediaProps) => {
  const { data: mediaItems, isLoading } = useQuery({
    queryKey: ['opportunity-media', opportunityId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('opportunity_media')
        .select('*')
        .eq('opportunity_id', opportunityId)
        .eq('is_public', true);

      if (error) throw error;
      return data;
    },
  });

  if (isLoading) {
    return (
      <div className="animate-pulse bg-muted h-48 rounded-lg" />
    );
  }

  if (!mediaItems?.length) {
    return null;
  }

  return (
    <Carousel className="w-full">
      <CarouselContent>
        {mediaItems.map((item) => (
          <CarouselItem key={item.id}>
            <AspectRatio ratio={16 / 9}>
              {item.media_type === 'video' ? (
                <video
                  src={item.media_url}
                  controls
                  className="rounded-lg object-cover w-full h-full"
                />
              ) : (
                <img
                  src={item.media_url}
                  alt="Opportunity media"
                  className="rounded-lg object-cover w-full h-full"
                />
              )}
            </AspectRatio>
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious />
      <CarouselNext />
    </Carousel>
  );
};